import { NavItemType } from "types";

import { getProjectsNav } from "./projects";

export const getNavMenuItems = (): { items: NavItemType[] } => {
  const items = [getProjectsNav()];

  return { items };
};
